module.exports = __webpack_public_path__ + "static/media/brown.c4c46540.svg";